import { formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency, withPrimaryCurrency } from "utils/helpers/currency/currencyHelpers";
import { useSettings } from "context/SettingsContext";

type ProductOperPriceProps = {
    operation: any;
    /** У об'єкті — ціна продажу; у складі (за замовч.) — курс грн */
    showSalePrice?: boolean;
    onSaleClick?: (price: number, priceRate: number) => void;
};

const ProductOperPrice = ({operation, showSalePrice = false, onSaleClick}: ProductOperPriceProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;

    const price = formatPrice(operation?.operPrice);
    const priceSale = formatPrice(operation?.operPriceSale);
    const priceRate = formatPrice(operation?.operPriceRate);
    const priceSaleRate = formatPrice(operation?.operPriceSaleRate);

    return (<>
        <h6 className="mb-1">{withPrimaryCurrency(price, rate)}</h6>
        {showSalePrice ? (
            <p
                className={`f-12 mb-0 text-truncate text-primary${onSaleClick ? ' cursor-pointer' : ''}`}
                onClick={() => {
                    if (onSaleClick) onSaleClick(operation?.operPriceSale, operation?.operPriceSaleRate);
                }}
                title={isUahMode ? undefined : withLocalCurrency(priceSaleRate)}
            >
                {withPrimaryCurrency(priceSale, rate)}
            </p>
        ) : (
            !isUahMode && (
                <p className="text-muted f-12 mb-0 my-1">{withLocalCurrency(priceRate)}</p>
            )
        )}
    </>)
}
 
export default ProductOperPrice;
